module.exports = __webpack_public_path__ + "static/media/CTLI_6-391w.942a0f86.webp";